import { fromPromise } from 'xstate';

/**
 * Generic auth token actor that should be overridden with platform-specific implementation.
 * Override this actor when creating the machine actor using the `actors` option.
 */
export const getAuthToken = fromPromise<{ token: string | undefined }>(
  async () => {
    throw new Error(
      'getAuthToken actor must be overridden with a platform-specific implementation',
    );
  },
);
